import api from "../helpers/api";

class ListingService{

    getListings(params) {
        
        return api.get('/admin/listings', { params });
    }
    
    getPremiumListings(params) {
        return api.get('/listings-premium', { params });
    }

    getListing(id) {
        return api.get(`/listings/${id}`);
    }
      
    async createListing(data) {
        console.log(typeof(data.fields))
        return await api.post(`/listings`,
           data,
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            return response;
        });
    }
    updateListing(id, data) {
        return api.put(`/listings/${id}`, data);
    }

    deleteListing(id) {
        return api.delete(`/listings/${id}`);
    }

    // Admin validation endpoint
    validateListing(id, data) {
        return api.post(`/listings/${id}/validate`, data);
    }    
   
}
export default new ListingService;